export default __webpack_public_path__ + "static/media/proposal-offer.c0de8c20.svg";